import { usePortalMetadataQuery } from '@/lib/data-hooks';
import { isNotFound } from '@tanstack/react-router';
import type { HTMLAttributes } from 'react';
import { useCampaignDisplayContext } from './campaign-display-context';
import { usePortalDisplayContext } from './portal-display-context';

function normalizePrimaryColor(color: string) {
	return color === '#ffffff' || color === '#fdfdfd' ? '#000000' : color;
}

export function DivWithPrimaryColorVariable(props: HTMLAttributes<HTMLDivElement>) {
	const displayData = useCampaignDisplayContext();
	const portalData = usePortalDisplayContext();

	if (displayData) {
		const primaryColor = normalizePrimaryColor(displayData.metadata.color);
		return <div {...props} style={{ '--primary': primaryColor, '--ring': primaryColor } as React.CSSProperties} />;
	}
	if (portalData) {
		const primaryColor = normalizePrimaryColor(portalData.color);
		return <div {...props} style={{ '--primary': primaryColor, '--ring': primaryColor } as React.CSSProperties} />;
	}
	return <DivFromMetadata {...props} />;
}

function DivFromMetadata(props: HTMLAttributes<HTMLDivElement>) {
	const metadata = usePortalMetadataQuery();

	if (isNotFound(metadata)) return <div {...props} />;

	const primaryColor = normalizePrimaryColor(metadata.color);

	return <div {...props} style={{ '--primary': primaryColor, '--ring': primaryColor } as React.CSSProperties} />;
}
